import { render, staticRenderFns } from "./coffee.vue?vue&type=template&id=a3e0833a&"
import script from "./coffee.vue?vue&type=script&lang=js&"
export * from "./coffee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports